import { queryKey } from 'Shared/const/queryKey';
import { useTokenStore } from 'Shared/hooks/useTokenStore';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';
import type { GetPostCampaignOverviewRes } from '../../api/mapper';
import type { PostingQueryKey } from '../../api/queries';

export const useGetPostCampaignOverview = (
  accountUuid: string,
  params?: QueryParam<
    GetPostCampaignOverviewRes,
    unknown,
    GetPostCampaignOverviewRes,
    PostingQueryKey['overviewList']['queryKey']
  >,
) => {
  const { accessToken } = useTokenStore();
  const queryResult = useSDQuery<
    GetPostCampaignOverviewRes,
    unknown,
    GetPostCampaignOverviewRes,
    PostingQueryKey['overviewList']['queryKey']
  >({
    ...params?.options,
    enabled:
      params?.options?.enabled !== undefined
        ? params.options.enabled
        : !!accessToken && !!accountUuid,
    gcTime: 10000,
    staleTime: 10000,
    ...queryKey.posting.overviewList({ accountUuid }),
  });
  return queryResult;
};
